import {BaseMyopMessage, Ref} from "./BaseMessage";

export class ChangeTextMessage extends BaseMyopMessage<string> {

    messageType = 'ChangeTextMessage';

    constructor(public ref: Ref, text: string) {
        super();
        this.content = text
    }
}